import { Button, Skeleton } from 'antd';
import type { HealthMetricType } from '../../fetchHooks/useHealthmetrictypesWithMeasurements';
import { useHealthmetrictypesWithMeasurements } from '../../fetchHooks/useHealthmetrictypesWithMeasurements.ts';

interface SelectHealthMetricsChecklistProps {
  selectedGraphs: HealthMetricType[];
  setSelectedGraphs: React.Dispatch<React.SetStateAction<HealthMetricType[]>>;
}

export const SelectHealthMetricsChecklist = ({
  selectedGraphs,
  setSelectedGraphs,
}: SelectHealthMetricsChecklistProps) => {
  const { data: healthmetrictypes, isLoading: isLoadingHealthmetrictypes } = useHealthmetrictypesWithMeasurements();
  if (isLoadingHealthmetrictypes) {
    return <Skeleton.Input active size="default" style={{ width: 300 }} />;
  }

  return (
    <div style={{ marginTop: '1rem' }}>
      <h4>Select Health Metrics to display:</h4>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '0.75rem',
          marginBottom: '1rem',
        }}
      >
        {healthmetrictypes?.map((metric) => (
          <label
            key={metric.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.5rem',
              border: '1px solid #e0e0e0',
              borderRadius: '4px',
              backgroundColor: selectedGraphs.some((selected) => selected.id === metric.id) ? '#f0f8ff' : 'transparent',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
            }}
          >
            <input
              type="checkbox"
              checked={selectedGraphs.some((selected) => selected.id === metric.id)}
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedGraphs((prev) => [...prev, metric]);
                } else {
                  setSelectedGraphs((prev) => prev.filter((selected) => selected.id !== metric.id));
                }
              }}
            />
            <span>
              {metric.description} ({metric.unit})
            </span>
          </label>
        ))}
      </div>
      <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
        <Button onClick={() => setSelectedGraphs(healthmetrictypes || [])} size="small">
          Select All
        </Button>
        <Button onClick={() => setSelectedGraphs([])} size="small">
          Clear All
        </Button>
      </div>
    </div>
  );
};
